<a [routerLink]="['..']" class="adap-link link-return">
  <mat-icon svgIcon="cvx-left"></mat-icon>
  global settings
</a>

<div class="group-container header">
  <div class="header-title">mandatory checks templates</div>
  <button
    class="adap-btn-filled add-mandatory-check-template-button"
    type="button"
    (click)="addMandatoryCheckTemplate()"
  >
    add mandatory check template <mat-icon svgIcon="cvx-plus-circle"></mat-icon>
  </button>
  <button class="adap-btn-blank" (click)="importExcel()">
    bulk upload templates <mat-icon svgIcon="cvx-upload"></mat-icon>
  </button>

  <app-mandatory-checks-templates-table
    (editMandatoryCheckTemplate)="editMandatoryCheckTemplate($event)"
    (deleteMandatoryCheckTemplate)="deleteMandatoryCheckTemplate($event)"
  ></app-mandatory-checks-templates-table>
</div>
